/**
 * WeaponType enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file WeaponType.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum WeaponType {
  INVALID = 0,
  PIERCING = 1,
  BLUDGEONING = 2,
  SLASHING = 3,
  SLASHING_AND_PIERCING = 4,
  PIERCE_AND_BLUDGEONING = 5,
}